export default {
    copy_link: '复制网址',
    committee_name: '归属商户',
    meeting_url: '会议网址',
    meeting_cn_name: '中文名称',
    meeting_en_name: '英文名称',
    meeting_desc: '会议简介',
    meeting_start_date: '会议开始时间',
    meeting_end_date: '会议结束时间',
    meeting_report_date: '现场报到时间',
    city_name: '所属省市',
    meeting_address_cn: '场馆中文名称',
    meeting_address_en: '场馆英文名称',
    meeting_credit_type: '学分类型',
    meeting_type: '会议类型',
    meeting_subject_class: '所属学科',
    meeting_link_person: '联系人',
    meeting_link_mobile: '手机号码',
    show_meeting_list: '是否显示在商户会议列表中',
    meeting_meta_keywords: '搜索引擎关键字',
    meeting_meta_description: '搜索引擎描述',
    meeting_tongji_code: '统计代码',
    phoneFormatReg: '手机号格式不正确',

    meeting_default_home: '网站默认首页',
    meeting_personal_lang: '个人中心语言',
    meeting_jump_type: '港澳台代表',
    meeting_welcome_pc: '欢迎页内容PC',
    meeting_welcome_h5: '欢迎页内容H5',
    meeting_welcome_link: '欢迎页制作方法',
    meeting_welcome_pc_tips: 'PC端欢迎页尺寸：1920*1080 「有效区域1140*600」 有效区域居中靠上',
    meeting_welcome_h5_tips: 'H5欢迎页尺寸：1080*1700 「有效区域700*1420」 有效区域居中靠上',

    meeting_image_980x200: '会议形象图（980*200px）',
    meeting_image_980x200_tips: '用于会议前台个人注册登录、团队注册登录、展商注册登录等图片尺寸为此比例的页面',
    meeting_image_900x500: '会议形象图（900*500px）',
    meeting_image_900x500_tips: '用于会议展示页面图片尺寸为此比例的页面',
    meeting_image_300x300: '会议形象图（300*300px）',
    meeting_image_300x300_tips: '用于会议链接分享图等图片尺寸为此比例的页面',
    meeting_image_affix: '建议尺寸<span class="error-color fs16 bold">{size}</span>px，支持JPG,GIF,PNG图片文件，文件大小不能超过2M',
    go_to_make: '去制作',

    // Dynamic Table Component
    add_row: '添加行', // 添加行
    target: '目标', // 目标
    link: '链接', // 链接
    title: '标题', // 标题
    jump_method: '跳转方式', // 跳转方式
    operation: '操作', // 操作
    delete: '删除', // 删除

    // Welcome Edit Component
    edit_pc_welcome: '编辑PC欢迎页', // 编辑PC欢迎页
    edit_h5_welcome: '编辑H5欢迎页', // 编辑H5欢迎页
    upload_image: '上传图片', // 上传图片
    generate_code: '生成代码', // 生成代码
    only_image_allowed: '只能上传图像文件' // 只能上传图像文件
};
